 $(document).ready(function() {
   
   // #MARQUEE EFECT***********
    const getAllMarquees = document.querySelectorAll('.ab__marquee');
    if(getAllMarquees){
      getAllMarquees.forEach(marquee => {
          const inner = marquee.querySelector('.ab__marquee-inner');
          const content = marquee.querySelector('.ab__marquee-content');
  
          const clone = content.cloneNode(true);
          inner.appendChild(clone);
          const speed = marquee.dataset.marqueeSpeed || '20s';
          const gap = marquee.dataset.marqueeGap || '1rem';
          const direction = marquee.dataset.marqueeDirection || 'left';
          const pause = marquee.dataset.marqueePause === 'true';
          const bgColor = marquee.dataset.marqueeBg || 'transparent';
  
          inner.style.setProperty('--marquee-speed', speed);
          inner.style.setProperty('--marquee-gap', gap);
          marquee.style.setProperty('--marquee-bg', bgColor);
          if (direction === 'right') inner.classList.add('reverse');
          if (pause) inner.classList.add('pause-on-hover');
      });
    }
    // #CLOSE AB ANNOUNCEMENT**********
    $(".ab-announcement-close").click(function() {
      $(".ab-announcement").slideUp()
    });

    // #MAIN HEADER***********
     $('.ab-navigation-icon').on('click', function(e) {
        e.stopPropagation(); 
        $(this).toggleClass('open');
        $('body').toggleClass('is-active')
        if ($(this).hasClass('open')) {
            $('.ab-mobile-menu').slideDown();
        } else {
            $('.ab-mobile-menu').slideUp();
        }
    });
    
    $(document).on('click', function(e) {
        if (!$(e.target).closest('.ab-mobile-menu, .ab-navigation-icon').length) {
            $('.ab-navigation-icon').removeClass('open');
            $('body').removeClass('is-active');
            $('.ab-mobile-menu').slideUp();
        }
    });

  // #HEADER STICKY***********
  const $header = $('.ab-sticky-wrapper');
  const headerOffset = $header.offset().top;

  $(window).scroll(function() {
      if ($(window).scrollTop() > headerOffset) {
          $header.addClass('sticky');
      } else {
          $header.removeClass('sticky');
      }
  });


  // #HEADER SEARCH ICON***********
  $('.js-header-search-icon').on('click', function (e) {
     e.preventDefault();
    $(this).toggleClass('active');
    $('.ab-search').slideToggle(250);
    setTimeout(() => $('.ab-search input[type="text"]').focus(), 500);
  });
  
   
   
});
